module.exports = __webpack_public_path__ + "static/future-of-work-most-workers-want-to-come-back-to-the-office-92824e2061aa9239f81984f5874126eb.png";